module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-right-up-8cc65d098edfd5c076fbe86a72d8c907.svg";